import { h } from "@stencil/core";
const baseClass = "ux-modal__multi";
export const ModalMultiIndicator = ({ total, current }) => {
    if (total <= 1) {
        return null;
    }
    return (h("div", { class: `${baseClass}` }, h("ux-steps", { items: total, current: current })));
};
//# sourceMappingURL=modal-multi-indicator.js.map
